import { Navigate, useLocation, useParams } from "react-router-dom";

export default function BlogCaseStudiesRedirect() {
  const { id } = useParams();
  const location = useLocation();

  if (location.pathname.startsWith("/blog/")) {
    return <Navigate to={`/blogs/${id}`} replace />;
  }
  if (location.pathname.startsWith("/casestudies/")) {
    return <Navigate to={`/case-studies/${id}`} replace />;
  }
  // Optionally, fallback to home or 404
  return <Navigate to="/" replace />;
}